import axios from 'axios';
import { instanceConfig, nameErrors } from '@common/api/httpClient';

const httpNoAuthClient = axios.create(instanceConfig);
nameErrors(httpNoAuthClient);

export default httpNoAuthClient;
